module.exports = __webpack_public_path__ + "media/images/creator/home/about-03-209355d1608bcfb992900985d8e678e7.png";